var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('span',[_vm._v("404")]),_c('span',[_vm._v("您访问的页面暂不在地球服务区内！o(╥﹏╥)o")]),_c('br'),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push('/home')}}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }